import React from 'react'
import { ApplicationForm } from '../form/ApplicationForm'

export const Registration = () => {
  return (
    <>
    <ApplicationForm/>
   
    </>
  )
}
